import { RichText } from '@hyphengroup/cms-components/components/RichText';
import { Tag } from '@hyphengroup/cms-components/components/Tag';
import { ExclusiveOfferBadgeColorEnum } from '@hyphengroup/cms-components/types/cmsEnums';
import {
  CmsGift,
  CmsOffer,
} from '@hyphengroup/cms-components/types/cmsProduct';
import { RewardCardImage } from './RewardCardImage';

type RewardCardProps = Pick<
  CmsGift,
  'desktop_image' | 'mobile_image' | 'gift_title' | 'additional_information'
> &
  Pick<CmsOffer, 'badge_color' | 'badge_tag'>;

export const RewardCard: React.FC<RewardCardProps> = ({
  desktop_image,
  mobile_image,
  gift_title,
  badge_color,
  badge_tag,
  additional_information,
}) => {
  return (
    <div className="border-collapse rounded-t-radius/card border border-borders/default">
      <div className="flex items-center gap-spacing/gap/x px-spacing/gap/x py-spacing/gap/y-sm">
        <div>
          <div className="hidden md:block">
            {(desktop_image || mobile_image) && (
              <RewardCardImage
                altText={gift_title}
                imageSrc={desktop_image || mobile_image}
                size="medium"
              />
            )}
          </div>
          <div className="block md:hidden">
            {(mobile_image || desktop_image) && (
              <RewardCardImage
                altText={gift_title}
                imageSrc={mobile_image || desktop_image}
                size="medium"
              />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          {badge_tag && (
            <div className="w-fit">
              <Tag
                size="large"
                color={(
                  badge_color ?? ExclusiveOfferBadgeColorEnum.Orange
                ).toLowerCase()}
              >
                <span>{badge_tag}</span>
              </Tag>
            </div>
          )}
          {gift_title && (
            <div className="mhg-alpha-title-1 md:mhg-alpha-typography-title-2 text-text-primary">
              {gift_title}
            </div>
          )}
          {additional_information && (
            <div className="mhg-alpha-typography-body-2 text-text/secondary-lighter">
              <RichText>{additional_information}</RichText>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
